import { buildCollection } from "@firecms/core";

export const titleStyleCollection = buildCollection({
  id: "title_style",
  name: "Title Style",
  path: "title_style",
  icon: "abc",
  group: "Style",
  textSearchEnabled: true,
  properties: {
    name: {
      dataType: "string",
      name: "Name",
      validation: {
        required: true,
      },
    },
    max_character_length: {
      dataType: "number",
      name: "Max Character Length",
      validation: {
        required: true,
        min: 0,
        integer: true,
        positive: true,
      },
    },
    text_color: {
      dataType: "string",
      name: "Text Color",
      description: "Text color in HEX",
      validation: {
        required: true,
        matches: "^#([A-Fa-f0-9]{6})$",
        matchesMessage: "Color must be a valid hex code (ex. #FFFFFF)",
      },
    },
    font_size: {
      dataType: "number",
      name: "Font Size",
      description: "Font size in DIP",
      validation: {
        required: true,
        positive: true,
        integer: true,
      },
    },
    horizontal_padding: {
      dataType: "number",
      name: "Horizontal Padding",
      description: "Horizontal padding in DIP",
      validation: {
        required: true,
        positive: true,
        integer: true,
      },
    },
    background: {
      dataType: "string",
      name: "Background",
      storage: {
        storagePath: "/image/board/title_background",
        fileName: "{rand}_{file}",
        acceptedFiles: ["image/*"],
        maxSize: 1 * 1024 * 1024,
      },
    },
    background_height: {
      dataType: "number",
      name: "Background Height",
      description: "Background height in DIP",
      validation: {
        positive: true,
        integer: true,
      },
    },
    font_file: {
      dataType: "string",
      name: "Font File",
      storage: {
        storagePath: "/font",
        fileName: "{rand}_{file}",
        acceptedFiles: [".ttf", ".otf"],
        maxSize: 1 * 1024 * 1024,
      },
    },
  },
});
